import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../context/AuthContext';

const DashboardContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3rem;
`;

const Title = styled.h1`
  color: #2d3748;
  margin: 0;
`;

const LogoutButton = styled.button`
  background-color: #e53e3e;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;

  &:hover {
    background-color: #c53030;
  }
`;

const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
`;

const Card = styled.div`
  background: white;
  border-radius: 10px;
  padding: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const CardTitle = styled.h2`
  color: #2d3748;
  margin-top: 0;
  margin-bottom: 1rem;
`;

const CardContent = styled.p`
  color: #4a5568;
  line-height: 1.6;
`;

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <DashboardContainer>
      <Header>
        <Title>Welcome to Your Dashboard</Title>
        <LogoutButton onClick={handleLogout}>Logout</LogoutButton>
      </Header>

      <ContentGrid>
        <Card>
          <CardTitle>Course Progress</CardTitle>
          <CardContent>
            You're making great progress! Continue learning to unlock more content.
          </CardContent>
        </Card>

        <Card>
          <CardTitle>Recent Activity</CardTitle>
          <CardContent>
            Your last activity was 2 days ago. Keep up the good work!
          </CardContent>
        </Card>

        <Card>
          <CardTitle>Upcoming Content</CardTitle>
          <CardContent>
            New course materials will be available next week. Stay tuned!
          </CardContent>
        </Card>
      </ContentGrid>
    </DashboardContainer>
  );
};

export default Dashboard; 